import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'visit-types');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'locations',
    {
      type: 'payload',
      selector: ['locationId'],
    },
    'visit_types',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/visit-type-by-location-req.js